var map = {
	"./circuit.svg": "32fa",
	"./circuit_white.svg": "15df",
	"./cool_down.svg": "aecc",
	"./cool_down_white.svg": "bd26",
	"./media.svg": "f709",
	"./run.svg": "0589",
	"./run_white.svg": "e003",
	"./warm_up.svg": "3ec6",
	"./warm_up_white.svg": "f641"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";